import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import useWindowSize from "hooks/useWindowSize";
import * as React from "react";
import { makeStyles, useTheme, Avatar, RaiseColors, Typography, Icon, IconConstants } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    avatarLight: {
      backgroundColor: RaiseColors.glacier2300,
      color: RaiseColors.grayscale900,
      border: "1px solid ".concat(RaiseColors.grayscale100),
      filter: "dropShadow(0px 2px 8px rgba(141, 139, 153, 0.10))"
    },
    avatarDark: {
      backgroundColor: RaiseColors.glacier900,
      color: RaiseColors.neutral100,
      border: "1px solid ".concat(RaiseColors.grayscale100),
      filter: "dropShadow(0px 2px 8px rgba(141, 139, 153, 0.10))"
    }
  };
});
var AvatarWithDefault = function AvatarWithDefault(_ref) {
  var _useWindowSize$innerW;
  var user = _ref.user,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "light" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "xs" : _ref$size;
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var theme = useTheme();
  var isMobile = windowSize < _valuesInstanceProperty(theme.breakpoints).lg;
  var classes = useStyles();
  var sizeMap = {
    xs: {
      typography: {
        variant: "paragraph_xsmall",
        weight: "medium"
      },
      empty: {
        fontSize: "12px"
      },
      avatar: {
        height: 32,
        width: 32
      }
    },
    sm: {
      typography: {
        variant: "paragraph_small",
        weight: "medium"
      },
      empty: {
        fontSize: "16px"
      },
      avatar: {
        height: 40,
        width: 40
      }
    },
    md: {
      typography: {
        variant: "paragraph_medium",
        weight: "medium"
      },
      empty: {
        fontSize: "20px"
      },
      avatar: {
        height: 48,
        width: 48
      }
    },
    lg: {
      typography: {
        variant: "paragraph_large",
        weight: "medium"
      },
      empty: {
        fontSize: "24px"
      },
      avatar: {
        height: 64,
        width: 64
      }
    }
  };
  var avatarSizeProps = sizeMap[size];
  var avatarVariantProps = variant === "light" ? classes.avatarLight : classes.avatarDark;
  if (user !== null && user !== void 0 && user.thumbnail) {
    return /*#__PURE__*/_jsx(Avatar, {
      classes: {
        root: avatarVariantProps
      },
      alt: user === null || user === void 0 ? void 0 : user.fullName,
      src: user === null || user === void 0 ? void 0 : user.thumbnail,
      sx: avatarSizeProps === null || avatarSizeProps === void 0 ? void 0 : avatarSizeProps.avatar
    });
  } else if (user !== null && user !== void 0 && user.initials) {
    return /*#__PURE__*/_jsx(Avatar, {
      classes: {
        root: avatarVariantProps
      },
      alt: user === null || user === void 0 ? void 0 : user.fullName,
      sx: avatarSizeProps === null || avatarSizeProps === void 0 ? void 0 : avatarSizeProps.avatar,
      children: /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
        color: variant === "light" ? RaiseColors.grayscale900 : RaiseColors.neutral100
      }, avatarSizeProps === null || avatarSizeProps === void 0 ? void 0 : avatarSizeProps.typography), {}, {
        children: user === null || user === void 0 ? void 0 : user.initials
      }))
    });
  } else {
    return /*#__PURE__*/_jsx(Avatar, {
      classes: {
        root: avatarVariantProps
      },
      alt: "profile_image",
      sx: avatarSizeProps === null || avatarSizeProps === void 0 ? void 0 : avatarSizeProps.avatar,
      children: /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, avatarSizeProps === null || avatarSizeProps === void 0 ? void 0 : avatarSizeProps.empty), {}, {
        className: IconConstants.USER
      }))
    });
  }
};
export default AvatarWithDefault;